module.exports = __webpack_public_path__ + "static/media/planleggje.a2c460f1.m4a";